export default __webpack_public_path__ + "assets/43654a1f1f84113a13318eaa169adcc9.png";